import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    GET_MODULECLE_CONTENTS_REQUEST,
    createModuleCleContentFail,
    createModuleCleContentSuccess,
    deleteModuleCleContentFail,
    deleteModuleCleContentSuccess,
    getModuleCleContentFail,
    getModuleCleContentSuccess,
    getModuleCleContentsFail,
    getModuleCleContentsSuccess,
    reorderModuleCleContentsFail,
    reorderModuleCleContentsSuccess,
    setModuleCleContentLoading,
    updateModuleCleContentFail,
    updateModuleCleContentSuccess,
} from "../actions/moduleCleContentActions";
import { API_BASE_URL, deleteRequest, extractErrorMessage, getRequest, postRequest, putRequest } from "../../../api";
import { uploadScormPackageApi } from "../../services/moduleScormApi";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

const buildFormData = (payload, file) => {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload || {}));
    if (file) {
        formData.append("file", file);
    }
    return formData;
};

export function* getModuleCleContentsSaga(action) {
    const { moduleCleId } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents`;

    yield put(setModuleCleContentLoading(true));
    try {
        const response = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getModuleCleContentsSuccess(moduleCleId, response.data || []));
    } catch (error) {
        yield put(getModuleCleContentsFail(extractErrorMessage(error, "Impossible de charger les contenus du ModuleCle.")));
    } finally {
        yield put(setModuleCleContentLoading(false));
    }
}

export function* getModuleCleContentSaga(action) {
    const { moduleCleId, contentId } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents/${contentId}`;

    yield put(setModuleCleContentLoading(true));
    try {
        const response = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getModuleCleContentSuccess(response.data));
    } catch (error) {
        yield put(getModuleCleContentFail(extractErrorMessage(error, "Impossible de charger le contenu.")));
    } finally {
        yield put(setModuleCleContentLoading(false));
    }
}

export function* createModuleCleContentSaga(action) {
    const { moduleCleId, payload, file, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents`;

    yield put(setModuleCleContentLoading(true));
    try {
        const response = yield call(postRequest, {
            url,
            uid: getUid(),
            token: getToken(),
            data: buildFormData(payload, file),
        });
        yield put(createModuleCleContentSuccess(response.data));
        if (payload?.contentType === "SCORM" && file && response.data?.id) {
            try {
                yield call(uploadScormPackageApi, moduleCleId, response.data.id, file);
            } catch (scormError) {
                yield call([Swal, Swal.fire], {
                    icon: "warning",
                    title: "Contenu cree, package SCORM non parse",
                    text: extractErrorMessage(scormError, "Impossible d'importer le package SCORM."),
                });
            }
        }
        yield put({ type: GET_MODULECLE_CONTENTS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Contenu créé.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) {
            callbacks.onSuccess(response.data);
        }
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de créer le contenu.");
        yield put(createModuleCleContentFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) {
            callbacks.onError(message);
        }
    } finally {
        yield put(setModuleCleContentLoading(false));
    }
}

export function* updateModuleCleContentSaga(action) {
    const { moduleCleId, contentId, payload, file, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents/${contentId}`;

    yield put(setModuleCleContentLoading(true));
    try {
        const response = yield call(putRequest, {
            url,
            uid: getUid(),
            token: getToken(),
            data: buildFormData(payload, file),
        });
        yield put(updateModuleCleContentSuccess(response.data));
        if (payload?.contentType === "SCORM" && file && response.data?.id) {
            try {
                yield call(uploadScormPackageApi, moduleCleId, response.data.id, file);
            } catch (scormError) {
                yield call([Swal, Swal.fire], {
                    icon: "warning",
                    title: "Contenu mis a jour, package SCORM non parse",
                    text: extractErrorMessage(scormError, "Impossible d'importer le package SCORM."),
                });
            }
        }
        yield put({ type: GET_MODULECLE_CONTENTS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Contenu mis à jour.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) {
            callbacks.onSuccess(response.data);
        }
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de modifier le contenu.");
        yield put(updateModuleCleContentFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) {
            callbacks.onError(message);
        }
    } finally {
        yield put(setModuleCleContentLoading(false));
    }
}

export function* deleteModuleCleContentSaga(action) {
    const { moduleCleId, contentId, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents/${contentId}`;

    yield put(setModuleCleContentLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteModuleCleContentSuccess({ moduleCleId, contentId }));
        yield put({ type: GET_MODULECLE_CONTENTS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Contenu supprimé.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) {
            callbacks.onSuccess();
        }
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de supprimer le contenu.");
        yield put(deleteModuleCleContentFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) {
            callbacks.onError(message);
        }
    } finally {
        yield put(setModuleCleContentLoading(false));
    }
}

export function* reorderModuleCleContentsSaga(action) {
    const { moduleCleId, sectionId, orderedContentIds, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/contents/reorder`;

    try {
        const response = yield call(putRequest, {
            url,
            uid: getUid(),
            token: getToken(),
            data: { sectionId, orderedContentIds },
        });
        yield put(reorderModuleCleContentsSuccess(moduleCleId, response.data || []));
        if (callbacks.onSuccess) {
            callbacks.onSuccess(response.data || []);
        }
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de réordonner les contenus du ModuleCle.");
        yield put(reorderModuleCleContentsFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) {
            callbacks.onError(message);
        }
    }
}
